'use client';

/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// UI lib components
import { Box } from '@mantine/core';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

function SectionAnnotations() {
  return <Box>Section annotations</Box>;
}

export default SectionAnnotations;
